import { render } from "./ListBASTProxy.vue?vue&type=template&id=89705f56&scoped=true"
import script from "./ListBASTProxy.vue?vue&type=script&lang=js"
export * from "./ListBASTProxy.vue?vue&type=script&lang=js"

import "./ListBASTProxy.vue?vue&type=style&index=0&id=89705f56&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89705f56"]])

export default __exports__